import React, { memo } from 'react';
import PropTypes from 'prop-types';

export const SearchIcon = memo(({ width=17, height=17, color='#596164' }) => {
    return (
        <svg width={width} height={height} fill={color} viewBox='0 0 25 24'>
            <path d='M21.3499432,2.78642045 C17.8164545,-0.747068182 12.0879886,-0.747068182 8.5545,2.78642045 C5.02101136,6.31967045 5.02101136,12.048375 8.5545,15.5818636 C12.0879886,19.1153523 17.8164545,19.1153523 21.3499432,15.5818636 C24.8834318,12.048375 24.8834318,6.31990909 21.3499432,2.78642045 L21.3499432,2.78642045 Z M20.3397955,14.5719545 C17.3642386,17.5472727 12.5402045,17.5472727 9.56464773,14.5719545 C6.58932955,11.5963977 6.58932955,6.772125 9.56464773,3.79680682 C12.5402045,0.821488636 17.3644773,0.82125 20.3397955,3.79680682 C23.3151136,6.77236364 23.3151136,11.5961591 20.3397955,14.5719545 L20.3397955,14.5719545 Z'></path>
            <path d='M6.7597875,15.2348625 L0.0253831705,21.9692668 L2.04570447,23.9895881 L8.7801088,17.2551838 L6.7597875,15.2348625 L6.7597875,15.2348625 Z' strokeWidth='0'></path>
        </svg>
    );
});

SearchIcon.displayName = 'SearchIcon';

SearchIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string
};
